import React, {useContext, useState} from 'react';
import logo from '../../../../../assets/security-details-upload-order-list.svg';
import styles from './submit-orders.module.scss';
import ModalCustom from "../../../../../components/modal/modal";
import {Button, Col, Row, Spinner} from "react-bootstrap";
import warningIcon from "../../../../../assets/warning-orange.svg";
import SuccessModalContent from "../modal-content-success/modal-content-success";
import {ORDERS_SUBMIT_ERROR, ORDERS_SUBMIT_SUCCESS, SECURITY_SUBMITTED} from "../../../../../helpr/constants";
import ErrorModalContent from "../modal-content-error/modal-content-error";
import {
  SecurityContext,
  SecurityDispatchContext
} from "../../../../../context/security-context";
import SecurityService from "../../../../../services/security-service";

const SubmitOrders = () => {
  const action = 'Submit Sales Report';
  const [ show, setShow ] = useState(false);
  const [ style, setStyle] = useState(`${styles['submit-orders-modal']} ${styles['confirm-modal']}`);
  const onClose = () => setShow(false);

  return (
    <>
      <div onClick={() => setShow(true)} className={styles['logo']}>
        <img alt={action} src={logo} />
        <label>{action}</label>
      </div>
      <ModalCustom
        show={show}
        title={action}
        onClose={onClose}
        component={<SubmitOrderModalContent onClose={onClose} modalConfig={{setStyle}}/>}
        style={style} />
    </>
  );
}

const SubmitOrderModalContent = ({onClose, modalConfig}) => {
  const HEADER_STYLE = styles['submit-orders-modal'];
  const ERROR_STYLE = `${styles['error-modal']} ${styles['submit-orders-modal']}`;
  const SUCCESS_TITLE = "SALES REPORT SUBMITTED";
  const ERROR_TITLE = "A PROBLEM OCCURRED";
  const [ errorMsg, setErrorMsg] = useState({
    title: '',
    value: ''
  })
  const [ loading, setLoading] = useState(false);
  const [ page, setPage ] = useState(0);
  const { securityState } = useContext(SecurityContext);
  const { setSecurityState } = useContext(SecurityDispatchContext);
  const securityService = new SecurityService();
  const { setStyle} = modalConfig;

  const submitOrders = async () => {
    setLoading(true);
    try {
      await securityService.submitOrders(securityState.securityId);
      setSecurityState({
        ...securityState,
        securityStatus: SECURITY_SUBMITTED
      })
      setStyle(HEADER_STYLE);
      setPage(1);
    } catch(error) {
      console.log(error.response);
      if(error.message === 'Request failed with status code 405') {
        setErrorMsg({
          ...errorMsg,
          title: 'SALES REPORT SUBMISSION FAILED',
          value: 'You may have insufficient applications or exceeded your allocation.'
        });
      } else {
        setErrorMsg({
          ...errorMsg,
          title: ERROR_TITLE,
          value: ORDERS_SUBMIT_ERROR
        })
      }
      setStyle(ERROR_STYLE);
      setPage(2)
    } finally {
      setLoading(false);
    }
  }

  const close = () => {
    setStyle(`${styles['submit-orders-modal']} ${styles['confirm-modal']}`);
    onClose();
  }

  return page === 0 ? (
    <div className={styles['submit-orders']}>
      <Row>
        <Col lg={12}>
          <div>
            <h1>YOU ARE ABOUT TO EXECUTE A LEVEL 1 (MAKER) SUBMISSION OF SALES REPORT.</h1>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div>
            <img alt="Warning" src={warningIcon} />
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div className={styles['message']}>
            <p>
              <span className={styles['bold']}>Notice of Finality</span>
            </p>
            <p className={styles['statement']}>
              All information contained in the Sales Report is FINAL and can no longer be supplemented, deleted or revised.
            </p>
            <p className={styles['statement']}>
              By clicking the <span className={styles['bold']}>SUBMIT</span> button, we confirm that we have read,
              we understand and agree to the Notice of Finality of  the Submitted Sales Report, Selling Agent/Underwriter’s
              Certification of the Final Sales Report, and the Selling Agent/Underwriter’s Certification/Endorsement
              of the Applications to Purchase underlying the Final Sales Report:
            </p>
            <p>
              <span className={styles['bold']}>Notice of Finality of the Submitted Sales Report</span>
            </p>
            <p>
              A Final Sales Report may only be submitted once and when submitted it can no longer be supplemented, deleted or revised.
            </p>
            <p>
              The submitter is solely responsible for ensuring the accuracy of information electronically submitted,
              as well as the accuracy and completeness of the information contained in the Applications submitted.
            </p>
            <p>
              The PDS Group shall not be held liable for delay, errors in the information and default, failure,
              mistakes or negligence of the user and any losses arising therefrom.
            </p>
            <p>
              <span className={styles['bold']}>Selling Agent Certifications on the Submission of the Final Sales Report</span>
            </p>
            <p>
              We certify that this Sales Report being submitted is final.
            </p>
            <p>
              We declare that all information contained in this Final Sales Report is accurate and has been
              verified against the Applications to Purchase submitted by the Applicant-Purchasers electronically
              online or by file upload through us as the Selling Agent.
            </p>
            <p>
              We also declare that the bank account numbers indicated in the Sales Report for Applicants who nominate
              their bank accounts to be credited for coupon and maturity payments have been validated by us or
              will be validated by us and notified to the Registrar and/or Paying Agent not later than 30 days
              prior to the first coupon payment date, with the specific cash settlement bank to ensure that
              the bank account details, including the required format, conform with the specification of the Settlement Bank.
            </p>
            <p>
              We further declare, warrant and undertake that all Applications to Purchase accepted and submitted
              through and underlying this Final Sales Report are genuine, complete and accurate.
            </p>
            <p>
              We declare that this consolidated Final Sales Report contains the complete listing of all
              our accepted Applicant-Purchasers.
            </p>
            <p>
              We finally declare, warrant, and represent that we have obtained the required consents of the
              Applicant-Purchasers to the sharing of all information contained in the Applications to Purchase
              and sales reports to PDTC, in accordance with the Data Privacy Act of 2012 and its implementing
              rules and regulations.
            </p>
            <p>
              We acknowledge, understand and accept that PDTC shall rely solely on the information contained
              in the Final Sales Report and the declarations, warranties and undertakings in the immediately
              preceding paragraph, on the recording of the names and allotments of securities for each accepted
              Applicant-Purchaser including all details needed to create the registry account for the Applicant-Purchaser.
              We understand that PDTC will rely on the declarations, representations, and warranties set forth herein.
            </p>
            <p>
              <span className={styles['bold']}>Selling Agent’s / Underwriter’s Certification/ Endorsement of all Underlying Applications to Purchase: </span>
            </p>
            <p>
              We hereby declare that:
            </p>
            <ol className={styles['alpha']}>
              <li>
                <div>
                  The necessary know-your-client process was conducted on each Applicant pursuant to the Anti-Money
                  Laundering Act and the amendments thereto ("AMLA") as well as its implementing rules and
                  regulations ("IRR") and our own internal policies, including, but not limited to, doing the KYC on
                  the basis of a third-party reliance letter issued by the appropriate institution as allowed by AMLA
                  and its IRR;
                </div>
              </li>
              <li>
                <div>
                  The identity of the Applicant was duly established pursuant to the AMLA and its IRR;
                </div>
              </li>
              <li>
                <div>
                  To the best of the undersigned’s knowledge, all information provided to the Issuer and the Registrar
                  and Paying Agent regarding the Applicant are true, complete, current and correct;
                </div>
              </li>
              <li>
                <div>
                  Any and all authorizations and waivers from the Applicant necessary for the undersigned underwriter
                  or selling agent to disclose all information required by the Issuer and the Registrar and Paying Agent
                  to determine the eligibility of the Applicant have been duly obtained;
                </div>
              </li>
              <li>
                <div>
                  The Application is genuine and being made personally, freely and voluntarily by the Applicant who is
                  the user/ owner of the email to whom the Selling Agent has sent the invitation to apply for a  reservation;
                </div>
              </li>
              <li>
                <div>
                  For the Applicant who indicated to have its securities and/or its clients’ securities registered
                  under PDTC Nominee and lodged under its Depository Account and/or its Clients’ NoCD Accounts under
                  the PDTC Depository Participant, all evidence of the instructions by the Applicant to purchase the
                  Security shall be made available upon request of the Issuer, its agent/s and the regulators.
                </div>
              </li>
            </ol>
          </div>
        </Col>
      </Row>
      <Row className={styles['button-row']}>
        <Col xs={6} lg={6}>
          <div className={styles['submit-button']}>
            <Button variant="warning" disabled={loading} onClick={() => submitOrders()}>
              {loading ? <Spinner size="sm" animation="border" /> : 'SUBMIT'}
            </Button>
          </div>
        </Col>
        <Col xs={6} lg={6}>
          <div className={styles['cancel-button']}>
            <Button variant="secondary" onClick={() => close()}>CANCEL</Button>
          </div>
        </Col>
      </Row>
    </div>
  ) : ( page === 1
    ? <SuccessModalContent title={SUCCESS_TITLE} message={ORDERS_SUBMIT_SUCCESS} onClose={close}/>
    : <ErrorModalContent title={errorMsg.title} message={errorMsg.value} onClose={close}/>)
}



export default SubmitOrders;

